$(function() {
  //cookieのusermodeを取得
  var usermode = $.cookie('usermode');
  //toSpBtnViewを取得
  var toSpBtnView = $.cookie('toSpBtnView');
  // URLの判定
  var site = '';
  if (location.href.indexOf('www.daily.co.jp/') > 0) {
    site = 'pc';
  } else if (location.href.indexOf('sp.daily.co.jp/') > 0) {
    site = 'sp';
  }

  // UAの判定
  if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('iPad') > 0 ||
      navigator.userAgent.indexOf('iPod') > 0 ||
      navigator.userAgent.indexOf('Android') > 0 ||
      navigator.userAgent.indexOf('BlackBerry') > 0 ||
      navigator.userAgent.indexOf('Windows Phone') > 0
    ) {

    // SPサイトへの遷移ボタンの表示
    if (site == 'pc' && toSpBtnView != 'off') {
      var spBtnshow = document.createElement('p');
      spBtnshow.id = 'btnSPShow';
      spBtnshow.innerHTML = '<a href="#" class="btnSPShow">スマートフォン版を見る</a>';
      $(".wrapper").prepend(spBtnshow);
    }
  }

  // SPページに遷移
  $('#btnSPShow').on('click', function(){
    $.cookie('usermode', 'sp', { path: '/', domain: 'daily.co.jp'  });
    url = urlReplace('sp');
    location.href = url;
  });
});

function urlReplace(mode){
  url = location.href;
  if (mode == 'sp') {
    return url.replace('www.daily.co.jp', 'www.daily.co.jp');
  } else if (mode == 'pc') {
    return url.replace('sp.daily.co.jp', 'www.daily.co.jp');
  }
}
